// import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
// import okaidia from 'react-syntax-highlighter/dist/esm/styles/prism/okaidia';
// import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco, tomorrowNightBlue } from 'react-syntax-highlighter/dist/esm/styles/hljs';

const syntaxStyle = tomorrowNightBlue;
const syntaxCustomStyle = { border: '1px solid #ddd', padding: 20, borderRadius: 8 };

export const CodeBlock = (props) => (
  <SyntaxHighlighter {...props} style={syntaxStyle} customStyle={syntaxCustomStyle}>
    {props.children}
  </SyntaxHighlighter>
);
